<template>
  <div>
    <v-row v-if="showComponent" id="container" style="margin-top: 1.2rem">
      <v-col
        xl="3"
        lg="4"
        md="6"
        sm="12"
        xs="12"
        v-for="(table, idxc) in selectedTables"
        :key="idxc"
        class="panel-cell"
        align="center"
      >
        <div
          :ref="table.id"
          :key="timerCount"
          :class="
            showWaitingTime(table.update_time, table.id, true) < 1800000
              ? 'notification-green'
              : showWaitingTime(table.update_time, table.id, true) < 3600000
              ? 'notification-yellow'
              : 'notification-red'
          "
        >
          {{ showWaitingTime(table.update_time, table.id) }}
        </div>
        <v-btn
          :style="
            tableLocked(table)
              ? 'background-color: rgba(97, 84, 164, 0.3)'
              : `background-color: ${table.color}`
          "
          block
          tile
          depressed
          min-height="3.5rem"
          :color="table.color"
          return-object
          @click="onTableCellClick(table)"
        >
          <span class="white--text tile btn-md">{{ table.name }}</span>
        </v-btn>
      </v-col>
    </v-row>
    <tables-dialog
      v-if="addTableDialogOpen"
      :availableTables="availableTables"
      @addTable="onAddTable"
      @selectTable="onSelectTable"
      @saveTable="saveTable"
      @deleteTable="onDeleteTable"
      @closeTablesDialog="onCloseTablesDialog"
    ></tables-dialog>
    <floor-plan-dialog
      ref="floorPlanDialog"
      :availableTables="availableTables"
      :read-only-mode="true"
    ></floor-plan-dialog>

    <!-- Transfer loading overlay - GLOBALNI, preko cijelog ekrana -->
    <div
      v-if="isProcessingTransfer"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.90);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: all;
      "
    >
      <div style="text-align: center;">
        <v-progress-circular
          :size="120"
          :width="12"
          color="#04aa6d"
          indeterminate
        ></v-progress-circular>
        <div style="color: white; font-size: 24px; margin-top: 24px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.5);">
          Prebacivanje artikala...
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import rules from '@/plugins/rules'
import state from '@/state'
import { df, functions } from '@/plugins/firebase'
import { toISOLocal, clone } from '@/plugins/utils'
import TablesDialog from '@/modules/cash-register/components/dialogs/TablesDialog.vue'
import FloorPlanDialog from '@/modules/cash-register/components/dialogs/FloorPlanDialog.vue'
import { printOrder } from '@/libs/bixolon/order'
import Table from '@/model/Table'
import { v4 as uuidv4 } from 'uuid'
import EventBus from '@/plugins/event-bus'

export default {
  components: {
    TablesDialog,
    FloorPlanDialog
  },
  inject: ['showMsgBox', 'confirm', 'confirmClose', 'showLoader', 'hideLoader', 'openPdfPrint'],
  data: function () {
    return {
      showComponent: false,
      isProcessingTransfer: false, // Zaštita od duplih transfera
      data: {},
      selectedPrinter: null,
      timerCount: 0,
      user: undefined,
      manager: false,
      userId: undefined,
      r1DialogOpen: false,
      addTableDialogOpen: false,
      note: '',
      languages: [],
      language: undefined,
      receiptNumber: 1,
      bill_sequence: 0,
      offer_sequence: 0,
      last_receipt: '',
      receiptType: '',
      issueDate: '',
      minIssueDate: '',
      maxIssueDate: '',
      rules: {
        req: rules.req(),
        oib: rules.oib(),
        gt: rules.gt,
        arrReq: rules.arrReq()
      },
      listeners: [],
      type: '',
      paymentMethod: '',
      editMode: false,
      ordersView: false,
      selectedTable: {},
      selectedTables: [],
      availableTables: [],
      // destinationTable: {},
      initialTable: {},
      printers: [],
      orgUnits: [],
      selectedCard: undefined,
      tableNameSuffix: 1,
      templateConfig: {
        tables: {
          show: false
        },
        toolbar: {
          buttons: [],
          submenu_options: []
        }
      },
      receiptNote: null
    }
  },
  computed: {
  },

  watch: {
    editMode: {
      handler (nv, ov) {
      }
    },
    selectedTable: {
      immediate: true,
      deep: true,
      handler (newValue, _) {
        EventBus.$emit('update-table-selection', newValue)
      }
    },
    selectedTables: {
      handler (selectedTables) {
        clearInterval(this._updateTimer)
        if (selectedTables.length) {
          this._updateTimer = setInterval(() => this.timerCount++, 1000)
        }
      },
      immediate: true
    },
    beforeUnmount () {
      clearInterval(this._updateTimer)
    },
    // Vue 2.x equivalent of beforeUnmount
    beforeDestroy () {
      clearInterval(this._updateTimer)
    }
  },
  methods: {
    showWaitingTime (updateDate, tableId, mode = false) {
      const diff = new Date() - new Date(updateDate)
      const twoD = x => `${Math.floor(x)}`.padStart(2, '0')
      const HH = twoD((diff / (60 * 60 * 1000)) % 24)
      const mm = twoD((diff / (60 * 1000)) % 60)
      const ss = twoD((diff / 1000) % 60)
      if (mode) return diff
      else { return `${HH}:${mm}:${ss}` }
    },

    // From split receipt
    async onCreateNewTable (sourceTable, destinationTable) {
      // ✅ Early return ako je transfer već u tijeku
      if (this.isProcessingTransfer) {
        console.warn('⚠️ Transfer već u tijeku, ignoriram dupli poziv')
        return
      }

      this.isProcessingTransfer = true
      console.log('🔄 Započinjem kreiranje novog stola...')

      try {
        this.selectedTable = clone(sourceTable)
        this.destinationTable = clone(destinationTable)

        await this.updateTable(this.selectedTable)
        await this.addSplitTable(this.destinationTable, this.selectedTable)

        this.selectedTable = new Table()
        EventBus.$emit('clear-selection')
        console.log('✅ Novi stol uspješno kreiran')

        // Emit event to clear pending quantities after creating new table
        EventBus.$emit('table-saved-clear-pending')

        // Čekaj da Vue ažurira DOM (košaricu) prije nego zatvorimo overlay
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 400))
        console.log('🎨 DOM ažuriran, zatvaram overlay')

        // Emituj EventBus event da je operacija završena
        EventBus.$emit('table-transfer-completed')
      } catch (error) {
        console.error('❌ Greška pri kreiranju novog stola:', error)

        // PRVO zatvori overlay i dijaloge
        console.log('RegisterTables: Resetiram isProcessingTransfer na false zbog greške')
        this.isProcessingTransfer = false
        EventBus.$emit('table-transfer-completed')

        // Čekaj da se overlay zatvori
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 200))

        // TEK ONDA prikaži grešku sa detaljima
        const errorMessage = error.message || error.toString() || 'Nepoznata greška'
        this.showMsgBox({
          title: 'Greška',
          text: `Dogodila se greška pri kreiranju novog stola:\n${errorMessage}\n\nMolimo pokušajte ponovo.`
        })
      } finally {
        // Flag je već resetiran u catch bloku ako je bilo greške
        console.log('RegisterTables: Finally blok - isProcessingTransfer =', this.isProcessingTransfer)
        this.isProcessingTransfer = false
      }
    },

    async onAddItemsToTable (sourceTable, targetTable, itemsToTransfer) {
      // ✅ Early return ako je transfer već u tijeku
      if (this.isProcessingTransfer) {
        console.warn('⚠️ Transfer već u tijeku, ignoriram dupli poziv')
        return
      }

      this.isProcessingTransfer = true

      try {
        const transferTableItemsApi = functions.httpsCallable('transfertableitems')
        await transferTableItemsApi({
          action: {
            resource_id: '',
            operation: 'create',
            entity: 'table_items',
            params: {
              from_table_id: sourceTable.id,
              to_table_id: targetTable.id,
              location_id: state.getPointOfSale().id,
              items: itemsToTransfer
            }
          }
        })

        await this.onNewOrder()
        console.log('✅ Transfer uspješno završen, košarica osvježena')

        // Emit event to clear pending quantities after transfer
        EventBus.$emit('table-saved-clear-pending')

        // Čekaj da Vue ažurira DOM (košaricu) prije nego zatvorimo overlay
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 500))
        console.log('🎨 DOM ažuriran, zatvaram overlay')

        // Emituj EventBus event da je transfer završen
        EventBus.$emit('table-transfer-completed')
      } catch (error) {
        console.error('❌ Greška pri transferu:', error)

        // PRVO zatvori overlay i dijaloge
        console.log('RegisterTables: Resetiram isProcessingTransfer na false zbog greške')
        this.isProcessingTransfer = false
        EventBus.$emit('table-transfer-completed')

        // Čekaj da se overlay zatvori
        await this.$nextTick()
        await new Promise(resolve => setTimeout(resolve, 200))

        // TEK ONDA prikaži grešku sa detaljima
        const errorMessage = error.message || error.toString() || 'Nepoznata greška'
        this.showMsgBox({
          title: 'Greška',
          text: `Dogodila se greška pri transferu artikala:\n${errorMessage}\n\nMolimo pokušajte ponovo.`
        })
      } finally {
        // Flag je već resetiran u catch bloku ako je bilo greške
        console.log('RegisterTables: Finally blok - isProcessingTransfer =', this.isProcessingTransfer)
        this.isProcessingTransfer = false
      }
    },
    tableLocked (table) {
      return !this.editMode && table.locked && table.locked_by !== state.getUser().id
    },
    switchLocks (newSelectedTable, oldSelectedTable) {
      this.lock(newSelectedTable)

      if (oldSelectedTable.id) {
        this.unlock(oldSelectedTable)
      } else {
        this.selectedTable = newSelectedTable
      }
    },
    async lock (newSelectedTable) {
      const me = this

      const newUpdateArgs = { locked: true, color: 'rgba(97, 84, 164, 0.95)', locked_by: state.getUser().id }
      df.doc(`location_orders/${state.getPointOfSale().id}/tables/${newSelectedTable.id}`).update(newUpdateArgs)
        .then(() => {
        }).catch((err) => {
          console.error(err)
          me.showMsgBox({ text: 'Pogreška prilikom zaključavanja', actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
        })
      this.selectedTable = newSelectedTable

      EventBus.$emit('select-table', newSelectedTable) // to RegisterInvoice, onSelectTable. Includes recalculate
      // this.$emit('selectTable', newSelectedTable)
    },
    async unlock (oldSelectedTable) {
      const me = this

      const oldUpdateArgs = { locked: false, color: 'primary' }
      df.doc(`location_orders/${state.getPointOfSale().id}/tables/${oldSelectedTable.id}`).update(oldUpdateArgs)
        .then(() => {
        })
        .catch((err) => {
          console.error(err)
          me.showMsgBox({ text: 'Pogreška prilikom zaključavanja', actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
        })
    },
    onOpenTablesDialog () {
      if (!this.orderHasChanged()) {
        this.addTableDialogOpen = true
      } else {
        this.confirm({
          title: this.$t('$vuetify.tables.note'),
          message: this.$t('$vuetify.tables.noteMessage'),
          options: {
            toolbar: true,
            width: 410,
            confirmText: this.$t('$vuetify.tables.continue'),
            cancelText: this.$t('$vuetify.tables.cancel')
          }
        }).then(async (resp) => {
          if (resp) {
            this.addTableDialogOpen = true
          }
          this.confirmClose()
        })
      }
    },
    onCloseTablesDialog () {
      this.addTableDialogOpen = false
    },
    async onAddTable (table) {
      if (this.selectedTable.id) {
        // Stol je odabran, ne spremati
        this.selectedTable = table
        this.initialTable = clone(this.selectedTable)
        this.clearOrderFromScreen()
        EventBus.$emit('select-table', table) // to RegisterInvoice, onSelectTable. Includes recalculate
        // this.$emit('selectTable', table)
        // this.$emit('recalculate')
      } else {
        // Stol nije odabran
        if (this.selectedTable.number !== 0) {
          const oldTb = clone(table)
          const newTb = clone(this.selectedTable)
          this.switchLocks(oldTb, newTb)
          this.initialTable = clone(newTb)
        } else {
          // ✅ FIX #3: Dohvati FRESH podatke iz baze prije dodavanja!
          console.log('🔵 Dohvaćam fresh podatke za stol:', table.name, 'ID:', table.id)
          const freshTable = await this.fetchFreshTableFromDb(table.id)

          if (freshTable) {
            // Koristimo fresh podatke iz baze
            this.selectedTable = freshTable
            console.log('✅ Fresh podaci dohvaćeni. Postojeći artikli:', freshTable.items ? freshTable.items.length : 0)

            // ✅ MERGE: Dodaj nove artikle NA postojeće artikle (ne pregazi!)
            const existingItems = freshTable.items || []
            const newItems = this.data.items || []

            // Merge: postojeći + novi artikli
            this.selectedTable.items = [...existingItems, ...newItems]
            console.log('✅ Merged ukupno artikala:', this.selectedTable.items.length, '(postojeći:', existingItems.length, '+ novi:', newItems.length, ')')
          } else {
            // Fallback ako ne možemo dohvatiti fresh podatke - koristi table iz availableTables
            console.warn('⚠️ Ne mogu dohvatiti fresh podatke, koristim cache')
            this.selectedTable = table
            this.data.items.forEach(item => {
              this.selectedTable.items.push(item)
            })
          }

          this.initialTable = clone(this.selectedTable)
          EventBus.$emit('select-table', this.selectedTable) // to RegisterInvoice, onSelectTable. Includes recalculate
          // this.$emit('selectTable', table)
        }
        this.onSaveItemsToTable()
      }
    },
    onSelectTable (table) {
      // ✅ FIX #4: NE pregažavaj selectedTable.items sa data.items!
      // Stari kod je bio opasan:
      // if (this.data && this.data.items && this.data.items.length > 0) {
      //   this.selectedTable.items = [...this.data.items]  // ❌ Ovo je brisalo postojeće artikle!
      // }

      // Track if we need to save items after selection
      const needsToSaveItems = this.data && this.data.items && this.data.items.length > 0 && table.id

      console.log('🔵 [onSelectTable] CALLED with table:', table.name, 'cart items:', this.data?.items?.length || 0, 'table items:', table.items?.length || 0)

      // ✅ Novi siguran kod: Ako ima novih artikala u košarici, MERGE ih (ne pregazi!)
      if (this.data && this.data.items && this.data.items.length > 0) {
        console.log('🛒 Cart items to merge:', this.data.items.map(item => ({
          name: item.name,
          organizational_unit_id: item.organizational_unit_id,
          hasOrgUnit: !!item.organizational_unit_id,
          org_units: item.org_units ? Object.keys(item.org_units) : 'undefined'
        })))

        // Provjeri da li selectedTable već ima artikle
        if (this.selectedTable.items && this.selectedTable.items.length > 0) {
          console.warn('⚠️ onSelectTable: selectedTable već ima', this.selectedTable.items.length, 'artikala. MERGE sa', this.data.items.length, 'novih.')
          // MERGE: zadržavamo postojeće + dodajemo nove
          this.selectedTable.items = [...this.selectedTable.items, ...this.data.items]
        } else {
          // Nema postojećih artikala, samo dodaj nove
          this.selectedTable.items = [...this.data.items]
        }
      }

      if (table.number === this.selectedTable.number) {
        this.selectedTable = table
        this.data.items = [...this.selectedTable.items]
        this.initialTable = clone(table)

        EventBus.$emit('select-table', table) // to RegisterInvoice, onSelectTable. Includes recalculate

        // this.$emit('selectTable', table) // PanelRows -> RegisterInvoice
        // this.$emit('recalculate') // PanelRows
      } else {
        const oldTb = clone(table)
        const newTb = clone(this.selectedTable)
        this.switchLocks(oldTb, newTb)
        this.initialTable = clone(table)

        EventBus.$emit('select-table', table) // to RegisterInvoice, onSelectTable. Includes recalculate

        // this.$emit('selectTable', table) // PanelRows
        // this.$emit('recalculate') // PanelRows
      }

      // ✅ FIX: Auto-save items when adding cart items to existing table
      if (needsToSaveItems) {
        console.log('🔄 Auto-saving items after merge to existing table')
        // Use nextTick to ensure DOM and state updates are complete
        this.$nextTick(() => {
          this.onSaveItemsToTable()
        })
      }
    },

    getOrder () {
      const orderId = uuidv4()
      const orderItems = []

      this.selectedTable.items.forEach((item, idx) => {
        let found = false
        if (this.selectedTable.items[idx].notes) {
          if (this.selectedTable.items[idx].notes[this.selectedTable.items[idx].notes.length - 1].currentNote) {
            this.selectedTable.items[idx].notes[this.selectedTable.items[idx].notes.length - 1].orderId = orderId
            this.selectedTable.items[idx].notes[this.selectedTable.items[idx].notes.length - 1].currentNote = false
          }
        }

        if (this.initialTable && this.initialTable.items) {
          this.initialTable.items.forEach(initItem => {
            if (item.id === initItem.id) {
              found = true
              if (item.quantity !== initItem.quantity) {
                const diff = item.quantity - initItem.quantity
                const itemClone = clone(item)
                itemClone.quantity = diff

                if (item.newKeys && initItem.newKeys) {
                  const oldKeys = []
                  Object.keys(item.newKeys).forEach(nKey => {
                    Object.keys(initItem.newKeys).forEach(iKey => {
                      if (nKey === iKey) {
                        oldKeys.push(nKey)
                      }
                    })
                  })

                  if (oldKeys && oldKeys.length > 0) {
                    oldKeys.forEach(key => {
                      delete itemClone.choosenProductOrder[key]
                      delete itemClone.choosenTagOrder[key]
                    })
                  }
                }
                orderItems.push(itemClone)
              }
            }
          })
        }

        if (!found) {
          const itemClone = clone(item)
          orderItems.push(itemClone)
        }
      })

      const order = {
        id: orderId,
        order_number: this.selectedTable.orders && this.selectedTable.orders.length > 0 ? this.selectedTable.orders.length + 1 : 1,
        added_by_name: state.getCashRegisterUser() && state.getCashRegisterUser().name ? state.getCashRegisterUser().name + ' ' + state.getCashRegisterUser().surname : state.getUser().name + ' ' + state.getUser().surname,
        added_by_id: state.getCashRegisterUser() && state.getCashRegisterUser().id ? state.getCashRegisterUser().id : state.getUser().id,
        order_status: 'ORDERED',
        order_items: orderItems,
        created_at: Date.now()
      }

      console.log('📦 [getOrder] Created order:', {
        orderId: order.id,
        orderNumber: order.order_number,
        orderItemsCount: orderItems.length,
        selectedTableItemsCount: this.selectedTable.items?.length || 0,
        orderItems: orderItems.map(item => ({
          name: item.name,
          quantity: item.quantity,
          organizational_unit_id: item.organizational_unit_id
        }))
      })
      return order
    },

    async onSaveItemsToTable () {
      if (this.data.items.length === 0) return

      console.log('🔵 [onSaveItemsToTable] Starting save process...')
      console.log('🔵 [onSaveItemsToTable] this.data.items:', this.data.items.length, 'items')
      console.log('🔵 [onSaveItemsToTable] this.selectedTable.items:', this.selectedTable.items?.length || 0, 'items')
      console.log('🔵 [onSaveItemsToTable] selectedTable.items content:', this.selectedTable.items?.map(item => ({
        name: item.name,
        organizational_unit_id: item.organizational_unit_id,
        hasOrgUnit: !!item.organizational_unit_id
      })))

      // ✅ FIX #5: BACKUP prije spremanja!
      console.log('🔵 Backup podataka prije spremanja...')
      const backupData = {
        items: clone(this.data.items),
        selectedTable: clone(this.selectedTable),
        initialTable: clone(this.initialTable)
      }
      console.log('✅ Backup kreiran:', backupData.items.length, 'artikala')

      try {
        this.showLoader('Spremam ' + this.selectedTable.name, { additionalTextTimer: 3500, additionalText: 'Oprostite što mi treba malo dulje, vaš internet se usporio.' })
        // ✅ FIX: DON'T overwrite selectedTable.items! It already contains the merged items from onSelectTable()
        // The old line `this.selectedTable.items = [...this.data.items]` was overwriting the merge
        // Now selectedTable.items already has the correct merged data (existing + new items)
        this.selectedTable.locked = true
        this.selectedTable.color = 'rgba(97, 84, 164, 0.95)'
        this.selectedTable.locked_by = state.getUser().id

        const order = this.getOrder()

        EventBus.$emit('send-notes', null, order) // to RegisterInvoice, onSendNotes

        const userName = state.getCashRegisterUser() && state.getCashRegisterUser().name
          ? state.getCashRegisterUser().name + ' ' + state.getCashRegisterUser().surname
          : state.getUser().name + ' ' + state.getUser().surname
        const userId = state.getCashRegisterUser() && state.getCashRegisterUser().id
          ? state.getCashRegisterUser().id
          : state.getUser().id

        const orderNote = order.notes
          ? order.notes.filter(n => n.message).map(n => n.message).join(', ')
          : ''

        const mappedItems = order.order_items.map(item => {
          if (item.notes && item.notes.length > 0) {
            const lastNote = item.notes[item.notes.length - 1]
            if (lastNote && lastNote.message) {
              return { ...item, note: lastNote.message }
            }
          }
          return item
        })

        const createOrderApi = functions.httpsCallable('createorder')
        await createOrderApi({
          action: {
            resource_id: '',
            operation: 'create',
            entity: 'order',
            params: {
              items: mappedItems,
              ...(orderNote && { order_note: orderNote }),
              location_id: state.getPointOfSale().id,
              table_id: this.selectedTable.id,
              user_id: userId,
              user_name: userName
            }
          }
        })

        if (!this.selectedTables.some(tbl => tbl.id === this.selectedTable.id)) {
          this.selectedTables.push(this.selectedTable)
        }

        console.log('✅ Spremanje uspješno! Čistim ekran...')
        this.clearOrderFromScreen()
        this.prepareOrderForPrint(order, this.selectedTable)
        this.initialTable = clone(this.selectedTable)

        EventBus.$emit('recalculate') // to RegisterInvoice, recalculate
        this.onNewOrder()

        EventBus.$emit('reset-notes') // to RegisterInvoice, onResetNotes
      } catch (err) {
        // ✅ FIX #5: Uhvati sve greške i restore iz backupa!
        console.error('❌ Greška prilikom spremanja:', err)
        this.data.items = backupData.items
        this.selectedTable = backupData.selectedTable
        this.initialTable = backupData.initialTable
        console.log('✅ Podaci vraćeni iz backupa nakon greške')

        this.hideLoader()
        this.showMsgBox({
          text: 'Greška pri spremanju narudžbe. Podaci su vraćeni na ekran. Molimo pokušajte ponovno.',
          title: 'Greška',
          actions: ['cancel'],
          cancelBtnText: 'U redu',
          color: 'error'
        })
      }
    },
    getOrderWithTimeout (tableId, orderId) {
      setTimeout(() => {
        return this.getLastOrderFromDb(tableId, orderId)
      }, 500)
    },
    async getLastOrderFromDb (tableId, orderId) {
      let dbOrder

      await df.doc(`location_orders/${state.getPointOfSale().id}/tables/${tableId}`)
        .get()
        .then((tableData) => {
          const tb = tableData.data()
          if (tb && tb.orders && tb.orders.length > 0) {
            tb.orders.forEach((or, index) => {
              if (or.id === orderId) {
                dbOrder = tb.orders[index]
              }
            })
          }
        })
      return dbOrder
    },
    async prepareOrderForPrint (order, table) {
      console.log('🔴 [RegisterTables] prepareOrderForPrint CALLED for order:', order?.id, 'table:', table?.name)
      const itemsInOrgUnits = {}
      if (order && order.order_items && order.order_items.length > 0) {
        order.order_items.forEach(item => {
          if (item.organizational_unit_id && item.organizational_unit_id !== '') {
            if (!itemsInOrgUnits[item.organizational_unit_id]) {
              itemsInOrgUnits[item.organizational_unit_id] = []
            }
            itemsInOrgUnits[item.organizational_unit_id].push(item)
          }

          if (item.choosenProductOrder) {
            Object.keys(item.choosenProductOrder).forEach(key => {
              if (item.choosenProductOrder[key] && item.choosenProductOrder[key].length > 0) {
                item.choosenProductOrder[key].forEach(product => {
                  if (product && product.productItems) {
                    product.productItems.forEach(it => {
                      if (it.org_units && it.org_units[state.getPointOfSale().id]) {
                        if (item.choosenTagOrder[key]) {
                          it.tags = item.choosenTagOrder[key]
                        }
                        it.menuId = key
                        it.menuData = {
                          productName: product.productName,
                          id: item.id,
                          name: item.name
                        }

                        if (!itemsInOrgUnits[it.org_units[state.getPointOfSale().id]]) {
                          itemsInOrgUnits[it.org_units[state.getPointOfSale().id]] = []
                        }

                        itemsInOrgUnits[it.org_units[state.getPointOfSale().id]].push(it)
                      }
                    })
                  }
                })
              }
            })
          }
        })

        var otherUnits = []
        Object.keys(itemsInOrgUnits).forEach(unitId => {
          this.orgUnits.forEach(orgUnit => {
            if (orgUnit.id === unitId) {
              otherUnits.push(orgUnit)
            }
          })
        })

        console.log('🔴 [RegisterTables] prepareOrderForPrint - Processing', Object.keys(itemsInOrgUnits).length, 'organizational units')
        Object.keys(itemsInOrgUnits).forEach(unitId => {
          const orgUnit = this.orgUnits.find(u => u.id === unitId)

          if (orgUnit) {
            const printer = this.printers.find(p =>
              p.id === orgUnit.printer || p.name === orgUnit.printer
            )

            if (printer) {
              console.log('🔴 [RegisterTables] Calling printAndSaveItems for unitId:', unitId, 'printer:', printer.name)
              this.printAndSaveItems(itemsInOrgUnits[unitId], printer, orgUnit, table, order, otherUnits)
            }
          }
        })
      }
    },
    async imidiatePrintPrepare (items) {
      console.log('🔴 [RegisterTables] imidiatePrintPrepare CALLED with', items?.length, 'items')
      const itemsInOrgUnits = {}
      if (items && items.length > 0) {
        items.forEach(item => {
          if (item.organizational_unit_id && item.organizational_unit_id !== '') {
            if (!itemsInOrgUnits[item.organizational_unit_id]) {
              itemsInOrgUnits[item.organizational_unit_id] = []
            }
            itemsInOrgUnits[item.organizational_unit_id].push(item)
          }

          if (item.choosenProductOrder) {
            Object.keys(item.choosenProductOrder).forEach(key => {
              if (item.choosenProductOrder[key] && item.choosenProductOrder[key].length > 0) {
                item.choosenProductOrder[key].forEach(product => {
                  if (product && product.productItems) {
                    product.productItems.forEach(it => {
                      if (it.org_units && it.org_units[state.getPointOfSale().id]) {
                        if (item.choosenTagOrder[key]) {
                          it.tags = item.choosenTagOrder[key]
                        }
                        it.menuId = key
                        it.menuData = {
                          id: item.id,
                          name: item.name
                        }

                        if (!itemsInOrgUnits[it.org_units[state.getPointOfSale().id]]) {
                          itemsInOrgUnits[it.org_units[state.getPointOfSale().id]] = []
                        }

                        itemsInOrgUnits[it.org_units[state.getPointOfSale().id]].push(it)
                      }
                    })
                  }
                })
              }
            })
          }
        })

        var otherUnits = []
        Object.keys(itemsInOrgUnits).forEach(unitId => {
          this.orgUnits.forEach(orgUnit => {
            if (orgUnit.id === unitId) {
              otherUnits.push(orgUnit)
            }
          })
        })

        console.log('🔴 [RegisterTables] imidiatePrintPrepare - Processing', Object.keys(itemsInOrgUnits).length, 'organizational units')
        Object.keys(itemsInOrgUnits).forEach(unitId => {
          const orgUnit = this.orgUnits.find(u => u.id === unitId)

          if (orgUnit) {
            const printer = this.printers.find(p =>
              p.id === orgUnit.printer || p.name === orgUnit.printer
            )

            if (printer) {
              console.log('🔴 [RegisterTables] Calling imidiatePrint for unitId:', unitId, 'printer:', printer.name)
              this.imidiatePrint(itemsInOrgUnits[unitId], printer, orgUnit, otherUnits)
            }
          }
        })
      }
    },
    async printAndSaveItems (items, printer, orgUnit, table, order, otherUnits) {
      console.log('🟠 [RegisterTables] printAndSaveItems CALLED with', items?.length, 'items, printer:', printer?.name, 'orgUnit:', orgUnit?.name)
      const orgUnitOrderId = uuidv4()
      const docRef = df.doc(`location_units/${state.getPointOfSale().id}/units/${orgUnit.id}/orders/${orgUnitOrderId}`)

      let note = null
      if (order.notes) {
        note = order.notes.find(n => n.unitId === orgUnit.id)
      }

      try {
        await docRef.set(
          {
            id: orgUnitOrderId,
            name: table && table.name ? table.name : 'Za van',
            number: order.order_number,
            order_added_by: state.getCashRegisterUser() ? state.getCashRegisterUser().name + ' ' + state.getCashRegisterUser().surname : state.getUser().name + ' ' + state.getUser().surname,
            items: items,
            printer_address: printer.ip_address
          }
        )
        console.log('✅ [RegisterTables] Table successfully saved.')
      } catch (err) {
        console.error('Error saving order: ', err)
      }

      console.log('🟠 [RegisterTables] Calling printOrder now...')
      state.setPosPrinterSettings(2)

      try {
        const result = await printOrder(items, printer, table, order, orgUnit, otherUnits, note, this.hideLoader)

        if (!result || !result.success) {
          throw new Error(result ? result.error : 'Unknown error')
        }

        console.log('✅ [RegisterTables] Print successful')
      } catch (err) {
        console.error('❌ [RegisterTables] Print failed:', err)

        // Show error to user with retry option
        EventBus.$emit('show-message-box', {
          title: 'Greška pri printanju',
          text: `Narudžba nije printana: ${err.message}. Želite li pokušati ponovno?`,
          actions: ['confirm', 'cancel'],
          confirmText: 'Pokušaj ponovno',
          cancelText: 'Odustani',
          color: 'error'
        })

        // Listen for retry - remove any existing listeners first
        EventBus.$off('message-box-confirm')
        EventBus.$once('message-box-confirm', async () => {
          await this.retryPrint(items, printer, orgUnit, table, order, otherUnits, note)
        })
      }
    },
    async retryPrint (items, printer, orgUnit, table, order, otherUnits, note, attempt = 1, maxAttempts = 3) {
      console.log(`🔄 [RegisterTables] Retry attempt ${attempt}/${maxAttempts}`)

      try {
        const result = await printOrder(items, printer, table, order, orgUnit, otherUnits, note, this.hideLoader)

        if (!result || !result.success) {
          throw new Error(result ? result.error : 'Unknown error')
        }

        // Success!
        EventBus.$emit('show-message-box', {
          text: '✅ Narudžba uspješno printana!',
          actions: ['cancel'],
          cancelText: 'OK',
          color: 'success'
        })
      } catch (err) {
        if (attempt < maxAttempts) {
          // Wait 2 seconds and retry
          await new Promise(resolve => setTimeout(resolve, 2000))
          await this.retryPrint(items, printer, orgUnit, table, order, otherUnits, note, attempt + 1, maxAttempts)
        } else {
          // Max attempts reached
          EventBus.$emit('show-message-box', {
            title: 'Printanje neuspješno',
            text: `Pokušano ${maxAttempts}x, ali printing nije uspio. Provjerite printer i pokušajte ponovno kasnije.`,
            actions: ['cancel'],
            cancelText: 'OK',
            color: 'error'
          })
        }
      }
    },
    async imidiatePrint (items, printer, orgUnit, otherUnits) {
      console.log('🟠 [RegisterTables] imidiatePrint CALLED with', items?.length, 'items, printer:', printer?.name)
      state.setPosPrinterSettings(2)

      try {
        const result = await printOrder(items, printer, undefined, undefined, orgUnit, otherUnits, undefined, this.hideLoader)

        if (!result || !result.success) {
          throw new Error(result ? result.error : 'Unknown error')
        }

        console.log('✅ [RegisterTables] Immediate print successful')
      } catch (err) {
        console.error('❌ [RegisterTables] Immediate print failed:', err)

        // Show error notification
        EventBus.$emit('show-message-box', {
          title: 'Greška pri printanju',
          text: `Narudžba nije printana: ${err.message}`,
          actions: ['cancel'],
          cancelText: 'OK',
          color: 'error'
        })
      }
    },
    saveItemsToDatabase (table, persist) {
      this.saveTable(table, persist)
    },
    orderHasChanged () {
      if (this.selectedTable.id && this.data.items && this.data.items.length > 0) {
        let itemCountDifferent = false
        const lengthDifferent = this.selectedTable.items.length !== this.data.items.length
        for (let i = 0; i < this.selectedTable.items.length; i++) {
          const tableItem = this.selectedTable.items[i]
          const cartItem = this.data.items.find(i => i.id === tableItem.id)
          if (tableItem && cartItem && tableItem.quantity !== cartItem.quantity) {
            itemCountDifferent = true
            break
          }
        }
        return itemCountDifferent || lengthDifferent
      }
    },
    onTableCellClick (table) {
      if ((!this.selectedTable.id && this.data.items && this.data.items.length > 0) || this.orderHasChanged()) {
        this.confirm({
          title: this.$t('$vuetify.tables.note'),
          message: this.$t('$vuetify.tables.noteMessage'),
          options: {
            toolbar: true,
            width: 410,
            confirmText: this.$t('$vuetify.tables.continue'),
            cancelText: this.$t('$vuetify.tables.cancel')
          }
        }).then(async (resp) => {
          if (resp) {
            if (table.receiptNote && table.receiptNote.note !== '') {
              this.receiptNote = { note: table.receiptNote.note }
              EventBus.$emit('save-receipt-note', this.receiptNote)
            }
            this.selectTable(table)
          }
          this.confirmClose()
        })
      } else {
        if (table.locked && table.locked_by !== state.getUser().id) {
          this.confirm({
            title: this.$t('$vuetify.tables.unlockTitle'),
            message: `${table.name} ${this.$t('$vuetify.tables.unlockMessageOther')}`,
            options: {
              toolbar: true,
              width: 410,
              confirmText: this.$t('$vuetify.yes'),
              cancelText: this.$t('$vuetify.no')
            }
          }).then(async (resp) => {
            if (resp) {
              if (this.selectedTable.number > 0) {
                df.doc(`location_orders/${state.getPointOfSale().id}/tables/${this.selectedTable.id}`).update({ locked: false, color: 'primary', locked_by: state.getUser().id })
              }

              this.selectedTable = table
              if (table.receiptNote && table.receiptNote.note !== '') {
                this.receiptNote = { note: table.receiptNote.note }
              }
              EventBus.$emit('clear-invoice', table)
              df.doc(`location_orders/${state.getPointOfSale().id}/tables/${table.id}`).update({ locked: true, color: 'rgba(97, 84, 164, 0.95)', locked_by: state.getUser().id })
                .catch((err) => {
                  console.error(err)
                  this.showMsgBox({ text: `Pogreška prilikom otključavanja: ${err}`, actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
                })
            }
            this.confirmClose()
          })
        } else if (!this.editMode) {
          if (table.receiptNote && table.receiptNote.note !== '') {
            this.receiptNote = { note: table.receiptNote.note }
            EventBus.$emit('save-receipt-note', this.receiptNote)
          }
          this.selectTable(table)
        }
      }
    },
    selectTable (table) {
      const tb = clone(table)
      this.onSelectTable(tb)
      EventBus.$emit('recalculate')
    },
    async onNewOrder () {
      if (this.selectedTable.id && !this.orderHasChanged()) {
        await this.createNewOrder(true)
      }

      if ((!this.selectedTable.id && this.data.items && this.data.items.length > 0) || this.orderHasChanged()) {
        this.confirm({
          title: this.$t('$vuetify.tables.note'),
          message: this.$t('$vuetify.tables.noteMessage'),
          options: {
            toolbar: true,
            width: 410,
            confirmText: this.$t('$vuetify.tables.continue'),
            cancelText: this.$t('$vuetify.tables.cancel')
          }
        }).then(async (resp) => {
          if (resp) {
            await this.createNewOrder(false)
          }
          this.confirmClose()
        })
      }

      this.hideLoader()
    },
    clearOrderFromScreen () {
      this.data.items = []
      this.receiptNote = null
      EventBus.$emit('save-receipt-note', null)
    },
    async createNewOrder (tableSelected) {
      if (tableSelected) {
        await df.doc(`location_orders/${state.getPointOfSale().id}/tables/${this.selectedTable.id}`).update({ locked: false, color: 'primary' })
      }
      this.selectedTable = new Table()
      this.clearOrderFromScreen()
      EventBus.$emit('select-table', this.selectedTable)
    },
    onClearOrder () {
      this.confirm({
        title: 'Ukloni narudžbu',
        message: `${this.$t('$vuetify.tables.clearOrder')} ${this.selectedTable.number}?</br></br> ${this.$t('$vuetify.tables.note')} </br> Svako brisanje narudžbe će biti zabilježeno.`,
        options: {
          toolbar: true,
          width: 410,
          confirmText: this.$t('$vuetify.yes'),
          cancelText: this.$t('$vuetify.no')
        }
      }).then(async (resp) => {
        if (resp) {
          this.confirmClose()
          this.removeOrderFromTable()
        }
      })
    },
    async removeOrderFromTable () {
      // this.selectedTable.items = []
      this.initialTable.items = []
      const tblIndex = this.selectedTables.findIndex((tbl) => tbl.number === this.selectedTable.number)
      if (tblIndex > -1) {
        this.selectedTable.items = []
        this.selectedTable.locked = false
        this.selectedTable.locked_by = ''
        this.selectedTables.splice(tblIndex, 1)
        this.selectedTable.orders = []
        this.onEmptyTable(this.selectedTable)
      }
      if (!this.selectedTable.persistent) {
        this.onDeleteTable(this.selectedTable)
      }

      this.selectedTable = new Table()
      EventBus.$emit('clear-selection')
    },
    onR1DialogClose () {
      this.r1DialogOpen = false
    },

    getTables () {
      const query = df.collection(`location_orders/${state.getPointOfSale().id}/tables`).orderBy('number')
      const listener = query.onSnapshot((doc) => {
        doc.docChanges().forEach((change) => {
          const table = change.doc.data()
          if (change.type === 'added') {
            // Provjeri items ILI orders (za tablove sa courses strukturom)
            const hasContent = (table.items && table.items.length > 0) || (table.orders && table.orders.length > 0)
            if (table && hasContent && ((this.manager) || (table.user_id && table.user_id === this.userId))) {
              this.selectedTables.push(table)
            }
          } else if (change.type === 'modified') {
            // ✅ FIX #1: Ne brišemo SVE stolove! Updateamo samo modificirani stol.
            const tableIndex = this.selectedTables.findIndex(t => t.id === table.id)

            if (tableIndex > -1) {
              // Stol već postoji u selectedTables
              // Provjeri items ILI orders (za tablove sa courses strukturom)
              const hasContent = (table.items && table.items.length > 0) || (table.orders && table.orders.length > 0)
              if (table && hasContent && ((this.manager) || (table.user_id && table.user_id === this.userId))) {
                // Stol ima artikle i pripada korisniku - updateaj ga
                // Provjeri da li je trenutno odabran stol
                const isCurrentlySelected = this.selectedTable && this.selectedTable.id === table.id

                // Ako je trenutno odabran I ima nespremljene promjene, NE updateaj ga automatski
                if (isCurrentlySelected && this.orderHasChanged()) {
                  // Korisnik radi na ovom stolu - ne diraj lokalne promjene!
                  console.warn('⚠️ Stol', table.name, 'modificiran u bazi, ali ima lokalne promjene - ne updateam')
                } else {
                  // Siguran update - nema lokalnih promjena
                  this.$set(this.selectedTables, tableIndex, table)

                  // Ako je trenutno odabran, updateaj i selectedTable
                  if (isCurrentlySelected) {
                    this.selectedTable = table
                  }
                }
              } else {
                // Stol više nema artikle ili ne pripada korisniku - ukloni ga
                this.selectedTables.splice(tableIndex, 1)
              }
            } else {
              // Stol nije u selectedTables - dodaj ga ako ima artikle
              if (table && table.items && table.items.length > 0 && ((this.manager) || (table.user_id && table.user_id === this.userId))) {
                this.selectedTables.push(table)
              }
            }

            // Updateaj availableTables također
            const availIndex = this.availableTables.findIndex(t => t.id === table.id)
            if (availIndex > -1) {
              this.$set(this.availableTables, availIndex, table)
            } else if (table) {
              this.availableTables.push(table)
            }

            // Ako modificirani stol nije locked za trenutnog korisnika
            if (table.locked_by !== state.getUser().id) {
              EventBus.$emit('clear-invoice', new Table()) // to RegisterInvoice, onClearInvoice
            }
          }
        })

        // ✅ FIX #1: Više ne trebamo fallback jer ne brišemo SVE stolove
        // Stari kod: if (this.selectedTables.length === 0) { this.selectedTables = [...tmpSelectedTables] }

        this.availableTables = []
        doc.docs.forEach((rec) => {
          const table = rec.data()
          const availableIndex = this.availableTables.findIndex((tbl) => tbl.id === table.id)
          if (availableIndex > -1) {
            this.availableTables.splice(availableIndex, 1, table)
          } else {
            this.availableTables.push(table)
          }
        })

        EventBus.$emit('set-available-tables', this.availableTables)
      })

      this.listeners.push(listener)
    },

    // ✅ FIX #2: Nova metoda - dohvaća najsvježije podatke o stolu iz baze
    async fetchFreshTableFromDb (tableId) {
      try {
        const doc = await df.doc(`location_orders/${state.getPointOfSale().id}/tables/${tableId}`).get()
        if (doc.exists) {
          return doc.data()
        } else {
          console.error('❌ Stol sa ID', tableId, 'ne postoji u bazi')
          return null
        }
      } catch (err) {
        console.error('❌ Greška pri dohvaćanju stola iz baze:', err)
        return null
      }
    },

    async updateTable (table) {
      const tbl = this.selectedTables.find(t => t.id === table.id)
      if (tbl) {
        var receiptNote = clone(this.receiptNote)
        this.receiptNote = null

        return df.doc(`location_orders/${state.getPointOfSale().id}/tables/${tbl.id}`).update({
          items: table.items,
          user_id: this.userId,
          user_name: this.user.name + ' ' + this.user.surname,
          update_time: Date.now(),
          receiptNote: receiptNote || ''
        })
          .then(() => {
            console.info('Table succesfully updated.')
          })
          .catch(() => {
            console.error('Table has not been updated succesfully.')
          })
      }
    },

    async addSplitTable (table, sourceTable) {
      const numberOfTables = this.selectedTables.filter(t => t.name.startsWith(this.selectedTable.name))
      this.tableNameSuffix = numberOfTables.length + 1
      const tbl = {
        color: table.color,
        id: uuidv4(),
        locked: false,
        locked_by: state.getUser().id,
        number: this.getCurrentTableNumber() + 1,
        name: `${sourceTable.name}/${this.tableNameSuffix}`,
        persistent: false,
        items: table.items,
        user_id: this.userId,
        user_name: this.user.name + ' ' + this.user.surname,
        update_time: Date.now()
      }
      const docRef = df.collection(`location_orders/${state.getPointOfSale().id}/tables`)

      try {
        await docRef.doc(tbl.id).set(tbl)
        console.info('Table successfully saved.')
      } catch (err) {
        console.error('Error saving table: ', err)
      }
    },

    getCurrentTableNumber () {
      if (this.availableTables.length === 0) {
        return 0
      }
      return Math.max(...this.availableTables.map(table => table.number))
    },

    async saveTable (table, persist) {
      let tblId, persistent, items
      if (table.id && table.id === this.selectedTable.id) {
        tblId = table.id
      } else {
        tblId = uuidv4()
        table.id = tblId
      }
      if (persist !== undefined) { persistent = persist } else { persistent = this.selectedTable.persistent }
      if (table.items.length > 0) { items = [...table.items] } else { items = [] }
      const docRef = df.doc(`location_orders/${state.getPointOfSale().id}/tables/${tblId}`)

      var receiptNote = clone(this.receiptNote)
      this.receiptNote = null

      console.log('💾 Saving table to Firebase. Orders:', table.orders)
      if (table.orders && table.orders.length > 0) {
        console.log('💾 Last order before save:', table.orders[table.orders.length - 1])
      }

      try {
        await docRef.set(
          {
            id: tblId,
            name: table.name,
            number: table.number,
            items: items,
            persistent: persistent,
            color: table.color ? table.color : '',
            locked: table.locked ? table.locked : false,
            locked_by: state.getUser().id,
            orders: table.orders && table.orders.length > 0 ? table.orders : [],
            user_id: this.userId,
            user_name: this.user.name + ' ' + this.user.surname,
            update_time: Date.now(),
            receiptNote: receiptNote || ''
          }
        )
        console.info('Table successfully saved.')
      } catch (err) {
        console.error('Error saving table: ', err)
      }
    },

    onEmptyTable (table) {
      EventBus.$emit('empty-table', table)
    },

    onDeleteTable (table) {
      if (table.id === this.selectedTable.id) {
        this.selectedTable = new Table()
      }
      EventBus.$emit('delete-table', table)
    },

    setDefaults () {
      this.languages = [
        { name: this.$t('$vuetify.receiptLanguages.hr'), value: 'hr' },
        { name: this.$t('$vuetify.receiptLanguages.en'), value: 'en' }
      ]
      this.language = this.languages[0]
      this.maxIssueDate = toISOLocal(new Date())
      this.issueDate = ''
    },

    detachListeners () {
      this.listeners.forEach((listener) => {
        listener()
        this.listeners = this.listeners.filter((l) => l !== listener)
      })
    },

    dateTimeToUnixTimestamp (dt) {
      return Math.floor(new Date(toISOLocal(dt)).getTime() / 1000)
    },

    setupTableContainer () {
      const ele = document.getElementById('container')
      if (ele) {
        let pos = { top: 0, left: 0, x: 0, y: 0 }
        const mouseDownHandler = function (e) {
          ele.style.cursor = 'grabbing'
          ele.style.userSelect = 'none'
          pos = {
            // The current scroll
            left: ele.scrollLeft,
            top: ele.scrollTop,
            // Get the current mouse position
            x: e.clientX,
            y: e.clientY
          }
          const mouseMoveHandler = function (e) {
            // How far the mouse has been moved
            const dx = e.clientX - pos.x
            const dy = e.clientY - pos.y

            // Scroll the element
            ele.scrollTop = pos.top - dy
            ele.scrollLeft = pos.left - dx
          }
          const mouseUpHandler = function () {
            document.removeEventListener('pointermove', mouseMoveHandler)
            document.removeEventListener('pointerup', mouseUpHandler)

            ele.style.cursor = 'grab'
            ele.style.removeProperty('user-select')
          }

          document.addEventListener('pointermove', mouseMoveHandler)
          document.addEventListener('pointerup', mouseUpHandler)
        }

        document.addEventListener('pointerdown', mouseDownHandler)
      }
    },
    resetTables () {
      const interval = setInterval(() => {
        if (this.selectedTables.length > 0) {
          clearInterval(interval)
          if (this.selectedTable.number === 0) {
            this.selectedTables.forEach((t) => {
              if (t.locked && t.locked_by === state.getUser().id) {
                df.doc(`location_orders/${state.getPointOfSale().id}/tables/${t.id}`).update({ color: 'primary', locked: false })
                  .catch((err) => {
                    console.error(err)
                    this.showMsgBox({ text: `Pogreška prilikom resetiranja: ${err}`, actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
                  })
              }
            })
          }
        }
      }, 100)
    }
  },

  created () {
    const interval = setInterval(() => {
      if (state.getTemplateConfig()) {
        this.templateConfig = state.getTemplateConfig()
        this.showComponent = this.templateConfig.tables && this.templateConfig.tables.show
        clearInterval(interval)
      }
    }, 100)

    EventBus.$on('cart-has-changed', (data) => {
      this.data = clone(data)
    })

    this.user = state.getCashRegisterUser().id ? state.getCashRegisterUser() : state.getUser()
    this.userId = this.user.id
    this.manager = !!(this.user.roles && this.user.roles.VODITELJ && this.user.roles.VODITELJ === true)
    this.selectedTable = new Table()
    this.getTables()
    this.resetTables()
  },

  mounted () {
    EventBus.$on('save-receipt-note', (receiptNote) => {
      this.receiptNote = receiptNote
    })

    // Listen for table transfer starting event (za overlay prikaz)
    EventBus.$on('table-transfer-starting', async () => {
      console.log('RegisterTables: Primio table-transfer-starting event')
      // Ne postavljamo isProcessingTransfer ovdje - to će napraviti sama metoda onAddItemsToTable/onCreateNewTable
      // Dodaj delay da se osigura da se overlay renderira nakon što metoda postavi flag
      await this.$nextTick()
      await new Promise(resolve => setTimeout(resolve, 100))
      console.log('RegisterTables: Čekam da metoda postavi isProcessingTransfer flag')
    })

    this.data.currency = 'EUR'

    this.selectedCard = undefined
    this.setupTableContainer()

    // Events from RegisterTableActions
    EventBus.$on('on-open-tables-dialog', () => { this.onOpenTablesDialog() })
    EventBus.$on('on-new-order', () => { this.onNewOrder() })
    EventBus.$on('on-clear-order', () => { this.onClearOrder() })
    EventBus.$on('on-save-items-to-table', () => { this.onSaveItemsToTable() })
    // End events from RegisterTableActions

    EventBus.$on('on-create-new-table', async (sourceTable, destinationTable) => { await this.onCreateNewTable(sourceTable, destinationTable) })
    EventBus.$on('on-add-items-to-table', async (sourceTable, targetTable, itemsToTransfer) => { await this.onAddItemsToTable(sourceTable, targetTable, itemsToTransfer) })

    EventBus.$on('clear-reload-tables', () => {
      // ✅ FIX #6: Provjeri da li ima nespremljenih promjena prije reload-a!
      if (this.orderHasChanged() && this.data && this.data.items && this.data.items.length > 0) {
        console.warn('⚠️ clear-reload-tables: Ima nespremljenih promjena! Upozoravam korisnika...')
        this.confirm({
          title: 'Upozorenje',
          message: 'Imate nespremljene artikle na stolu. Ako nastavite, promjene će biti izgubljene. Želite li spremiti prvo?',
          options: {
            toolbar: true,
            width: 410,
            confirmText: 'Nastavi bez spremanja',
            cancelText: 'Odustani'
          }
        }).then((resp) => {
          if (resp) {
            // Korisnik je potvrdio - nastavi sa clear-reload
            this.selectedTables = []
            this.getTables()
            this.selectedTable = new Table()
            this.clearOrderFromScreen()
          }
          this.confirmClose()
        })
      } else {
        // Nema nespremljenih promjena - siguran reload
        this.selectedTables = []
        this.getTables()
        this.selectedTable = new Table()
      }
    })

    EventBus.$on('clear-table', () => {
      this.removeOrderFromTable()
    })

    EventBus.$on('set-mode', (editMode) => {
      this.editMode = editMode
    })

    EventBus.$on('set-orders-view', (ordersView) => {
      this.ordersView = ordersView
    })

    this.setDefaults()
    this.minIssueDate = toISOLocal(new Date())
    this.listeners.push(
      df
        .doc(`cash_registers/${state.getCashRegister().id}`)
        .onSnapshot((doc) => {
          if (doc && doc.data()) {
            this.offer_sequence = doc.data().offer_sequence
            this.bill_sequence = doc.data().bill_sequence
            this.last_receipt = doc.data().last_receipt_issued_timestamp
            if (this.last_receipt) {
              this.minIssueDate = toISOLocal(
                new Date(this.last_receipt * 1000)
              )
            } else {
              this.minIssueDate = toISOLocal(new Date())
            }
          }
        })
    )

    this.orgUnits = []
    let query = df.collection(`location_units/${state.getPointOfSale().id}/units`)
    let listener = query.onSnapshot((doc) => {
      doc.docs.forEach((rec) => {
        this.orgUnits.push(rec.data())
      })
    })
    this.listeners.push(listener)

    this.printers = []
    query = df.collection(`location_printers/${state.getPointOfSale().id}/printers`)
    listener = query.onSnapshot((doc) => {
      doc.docs.forEach((rec) => {
        this.printers.push(rec.data())
      })
    })

    this.listeners.push(listener)
  },
  beforeDestroy () {
    // ✅ FIX #10: Cleanup Firestore listeners
    if (this.listeners) {
      this.detachListeners()
    }

    // ✅ FIX #10: KRITIČNO - Cleanup EventBus listeners da se izbjegne memory leak!
    console.log('🧹 Čistim EventBus listenere...')
    EventBus.$off('cart-has-changed')
    EventBus.$off('save-receipt-note')
    EventBus.$off('table-transfer-starting')
    EventBus.$off('on-open-tables-dialog')
    EventBus.$off('on-new-order')
    EventBus.$off('on-clear-order')
    EventBus.$off('on-save-items-to-table')
    EventBus.$off('on-create-new-table')
    EventBus.$off('on-add-items-to-table')
    EventBus.$off('clear-reload-tables')
    EventBus.$off('clear-table')
    EventBus.$off('set-mode')
    EventBus.$off('set-orders-view')
    console.log('✅ EventBus listeneri očišćeni')
  }
}
</script>

<style scoped>
#container {
  overflow-x: hidden;
  overflow-y: auto;
  cursor: grab;
  touch-action: none;
  /* border: 1px solid#fd0000; */
  margin-top: 12px;
}

@media only screen and (max-height: 899px) {
  #container {
    max-height: 193px;
  }
  span.tile {
    display: block;
    white-space: normal;
    max-width: 180px;
  }
}

@media only screen and (min-height: 900px) {
  #container {
    max-height: 440px;
  }
  span.tile {
    display: block;
    white-space: normal;
    max-width: 120px;
  }
}
.panel-cell {
  padding: 0 2px 2px 0;
}
.label {
  font-size: 0.6rem;
  color: white;
  min-width: 90px;
}
.text-wrap {
  width: min-content;
  margin: auto;
}
.disable-events {
  pointer-events: none;
  background-color: #e0e0e0;
}

.accent-btn {
  animation: glowing 700ms infinite;
  font-weight: 700;
}
.darkblue {
  background-color: #2c5a90;
}
.btn-lg {
  font-size: 1rem;
  font-weight: 700;
}
.btn-md {
  font-size: 0.8rem;
  font-weight: 700;
}
.btn-sm {
  font-size: 0.7rem;
  font-weight: 700;
}
.btn-purple {
  color: white;
  background-color: #b10090;
}
.notification-green {
  font-size: 12px;
  background-color: #8ff4a2;
  font-weight: bold;
}
.notification-yellow {
  font-size: 12px;
  background-color: #edf68b;
  font-weight: bold;
}
.notification-red {
  font-size: 12px;
  background-color: #e898a0;
  color: white;
  font-weight: bold;
}
</style>
